"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .ant-drawer-wrapper-body {\n    display: flex;\n    flex-direction: column;\n    > .ant-drawer-body {\n      flex-grow: 1;\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexDrawer = void 0;

var antd_1 = require("antd");

var styledTypes_1 = require("./styledTypes");

exports.FlexDrawer = (0, styledTypes_1.styled)(antd_1.Drawer)(_templateObject());